import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ComponentCanDeactivate} from './pending-changes.guard';
import {CanDeactivate} from '@angular/router';
import {AlertController} from '@ionic/angular';

@Injectable({providedIn: 'root'})
export class PendingLineCheckChangesGuard implements CanDeactivate<ComponentCanDeactivate> {

    constructor(private alertController: AlertController) {
    }

    canDeactivate(component: ComponentCanDeactivate): boolean | Observable<boolean> | Promise<boolean> {
        // If there are no pending changes, just allow deactivation; else confirm first.
        // Ionic alert rather than the original window.confirm(), to match the app's other
        // confirmation dialogs. (Closing/refreshing the tab still gets the browser's own
        // beforeunload prompt - browsers don't allow a custom dialog there.)
        return component?.canDeactivate() ? true : this.confirmLeave();
    }

    private async confirmLeave(): Promise<boolean> {
        const alert = await this.alertController.create({
            header: 'Line Check not submitted',
            message: 'You have not submitted this Line Check. If you leave now, all the data you have entered will be discarded.',
            backdropDismiss: false,
            buttons: [
                {text: 'Keep editing', role: 'cancel'},
                {text: 'Leave and discard', role: 'destructive'},
            ],
        });
        await alert.present();
        const {role} = await alert.onDidDismiss();
        return role === 'destructive';
    }
}
